.DataFormContainer
    position: absolute
    top: 0
    bottom: 0
    left: 0
    right: 0
    width: 100%
    display: flex
    flex: 1
    flex-direction: column
    align-items: center
    background: rgb($globalSettingsBackgroundPrimary)
    justify-content: space-between
    font-size: 14px
    color: rgb($globalSettingsFontPrimary)
    overflow: auto
    box-sizing: border-box
    .spinnerContainer
        position: absolute
        height: 100%
        width: 100%
        background: rgba($globalSettingsBackgroundPrimary, 0.7)
        z-index: 10
        display: flex
        justify-content: center
        align-items: center
        flex-direction: column
        gap: 20px

.DataFormContainerInner
    width: 100%
    padding: 0 20px
    display: flex
    flex-direction: column
    flex-shrink: 0
    box-sizing: border-box

.FieldsContainerFlex
    width: 100%
    display: flex
    flex-wrap: wrap
    justify-content: space-between
    column-gap: 20px
    .InputField
        flex-grow: 1
        width: 240px
        &.FullWidth
            width: 100%

.DataFormTitle
    font-size: 16px
    font-weight: 700
    width: 100%

.spacerOne
    display: none

.col-span-full
    grid-column: 1 / -1

@media #{$tablet}
    .MobileOnly
        display: none

    .DataFormContainerInner
        padding: 0 30px

    .CheckboxContainer
        width: 100%

    .spacerOne
        display: inherit
        width: 100%
        height: 30px
        flex-shrink: 0

    .OtherShippingAddress
        width: 100%
        display: flex
        flex-direction: row
        flex-wrap: wrap
        justify-content: space-between
        order: 100
        .spacerThree
            order: 4
            display: inherit
            width: 100%
            height: 30px
            flex-shrink: 0
        .spacerFour
            order: 10
            display: inherit
            width: 100%
            height: 30px
            flex-shrink: 0
